export var DRAWER_TYPE = "DRAWER";
export var DRAWER_GROUP_TYPE = "DRAWER_GROUP";
export var DRAWER_ITEM_TYPE = "DRAWER_ITEM";
